declare global {
	interface Window {
	  _env_: typeof process.env;
	}
}

if(process.env.NODE_ENV === "test")
{
	window._env_ = process.env;
}

/** this is the actual product version used internally to track builds and releases */
const productVersion = require('../package.json').version;

/** this is the product version displayed to the user in the UI */
export const productVersionFaceValue = "2.40 U1";

// injection of "build number" for development environment
if(window._env_?.ENVIRONMENT === "development")
{
	console.log("Development Environment");
	window._env_.RELEASE_VERSION = window._env_.RELEASE_VERSION || `${productVersion}_dev`;
}

export default {
	LIST_ASSETS_PATH: '/files/list',
	GET_ASSET_PATH: '/files/info',
	MOVE_ASSET_PATH: '/files/move',
	RENAME_ASSET_PATH: '/files/rename',
	CREATE_DIRECTORY_PATH: '/files/create/folder',
	UPLOAD_FILE_PATH: '/files/upload',
	DOWNLOAD_FILE_PATH: '/files/download',
	REMOVE_FILE_PATH: '/files/remove',
	VERIFY_FILE_PATH: '/files/upload/complete',
	LOAD_PROJECT_PATH: '/organization/projects/load',
	SAVE_PROJECT_PATH: '/organization/projects/save',
	UPDATE_PROJECT_STATUS_PATH: '/organization/projects/state',
	EXPORT_PROJECT_PATH: '/organization/projects/export',
	EXPORT_PROJECT_REVISION_PATH: '/organization/projects/export-revision',
	IMPORT_PROJECT_PATH: '/organization/projects/import',
	MERGE_PROJECT_PATH: '/organization/projects/merge',
	IMPORT_DEMO_PROJECT_PATH: '/organization/projects/import-demo',
	IMPORT_EXPORT_PROJECT_LIST_PATH: '/organization/projects/import-export-list',
	IMPORT_MERGE_PROJECT_LIST_PATH: '/organization/projects/import-merge-list',
	PUBLISH_OFFLINE_PROJECT_PATH: '/organization/projects/publish-offline',
	PUBLISH_PROJECT_PATH: '/organization/projects/publish-cms',
	CREATE_PROJECT_PATH: '/organization/projects/create',
	SET_PROJECT_RESOURCE_PERMISSIONS_PATH: '/organization/projects/update-resource-permissions',
	UNLIST_PROJECT_PATH: '/organization/projects/unlist',
	LIST_DEMO_PROJECT_PATH: '/demo-projects/list',
	GET_PROJECT_PATH: '/organization/projects/project',
	DELETE_PROJECT_PATH: '/organization/projects/project',
	RECENT_PROJECTS_TIME_FILTER: 7776000000, //90 days in Miliseconds
	GET_SCENARIO_WHITELIST: '/organization/projects/get-wl',
	ME_PATH: '/users/me',
	EULA_APPROVE_PATH: '/users/confirm-eula',
	RELEASE_NOTES_SEEN_PATH: '/users/set-release-notes-seen',
	UPDATE_WLC_SETTINGS_PATH: '/users/wlc-settings',
	LIST_JOBS_PATH: '/jobs/list',
	NEW_JOB_PATH: '/jobs/new',
	NEW_PREVIEW_RENDER_JOB_PATH: '/jobs/preview-render',
	GET_JOB_FOR_REVISION_PATH: '/jobs/get-job-for-revision',
	ASSET_ARCHIVE_INFO: '/files/archive-info',
	SCOPE_EXTENSION_VERSION: '12',
	EULA_VERSION: '1.0',
	SERVER_ADDRESS: window._env_.API_ADDRESS,
	CMS_LOGIN_ADDRESS: window._env_.CMS_LOGIN_ADDRESS,
	IOT_SERVER_ADDRESS: window._env_.IOT_SERVER_ADDRESS,
	AI_SERVER_ADDRESS: window._env_.AI_SERVER_ADDRESS,
	ENVIRONMENT: window._env_.ENVIRONMENT,
	ACCESS_TOKEN: window._env_.ACCESS_TOKEN,
	ANALYTICS: window._env_.ANALYTICS?.toLowerCase() === 'true',
	AIRBRAKE: window._env_.AIRBRAKE?.toLowerCase() === 'true',
	AIRBRAKE_PROJECT_ID: window._env_.AIRBRAKE_PROJECT_ID,
	AIRBRAKE_PROJECT_KEY: window._env_.AIRBRAKE_PROJECT_KEY,
	AIRBRAKE_ENVIRONMENT: window._env_.AIRBRAKE_ENVIRONMENT,
	USERFLOW_ENABLED: window._env_.USERFLOW_ENABLED?.toLowerCase() === 'true',
	USE_LEGACY_PUBLISH_RESTAPI: window._env_.USE_LEGACY_PUBLISH_RESTAPI?.toLowerCase() === 'true',
	USERFLOW_ENVIRONMENT_TOKEN: window._env_.USERFLOW_ENVIRONMENT_TOKEN,
	DISABLE_CRASH_REPORT: window._env_.ENVIRONMENT === "development",
	SESSION_REFRESH_TIME_IN_SECONDS: window._env_.SESSION_REFRESH_TIME_IN_SECONDS ? window._env_.SESSION_REFRESH_TIME_IN_SECONDS : 86400, // default value in case users have cached an older .env file
	CREATE_VERSION: productVersion,
	/**
	 * displays the full product version including the generated build number that's injected by the CI
	 * 
	 * fetch this value from the Utils.getProductVersionBuild() function to get a nicely formatted string
	 */
	RELEASE_VERSION: window._env_.RELEASE_VERSION, 
	CMS_JWT_SECRET: window._env_.CMS_JWT_SECRET,
	CMS_HOST: window._env_.CMS_HOST,
	CMS_GQL_ROUTE: window._env_.CMS_GQL_ROUTE,
	CMS_PROTOCOL: window._env_.CMS_PROTOCOL
};
